import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { deleteUserSegmentAbtest, updateUserSegmentAbtest } from '../../../services/api/Abtest';
import { IAbTestUpdateRequestDto, ISegmentCurationStatus, IUserSegment } from '../../../services/types';
import { AbtestScheduleCurationList } from './AbtestScheduleCurationList';
import useStyles from './styles';

interface IProps {
  onClickRowItem: (segmentItem: IUserSegment) => void;
  onError: (error: Error) => void;
  onClickCuration: (segmentItem: IUserSegment, mode: 'create' | 'edit') => void;
}

export const AbtestScheduleList = (props: IProps): JSX.Element => {
  const classes = useStyles();

  // states
  const [status, setStatus] = useState<ISegmentCurationStatus | 'all'>('all');

  // handlers
  const handleUpdateCuration = (curationId: number, data: IAbTestUpdateRequestDto) => {
    return updateUserSegmentAbtest(curationId, data);
  };

  const handleDeleteCuration = (curationId: number) => {
    return deleteUserSegmentAbtest(curationId);
  };

  // watches

  return (
    <div className={classes.root}>
      <Box style={{ width: '100%', marginTop: '8px', marginBottom: '14px', paddingLeft: '4px' }}>
        <Typography variant="h6" component="h3">
          A/B Test schedule
        </Typography>
        <Box paddingBottom={1}>
          <RadioGroup
            row
            value={status}
            name="status"
            onChange={e => {
              setStatus(e.target.value as ISegmentCurationStatus);
            }}
          >
            <FormControlLabel control={<Radio value="all" color="primary" className={''} />} label="All status" />
            <FormControlLabel control={<Radio value="activated" color="primary" />} label="Activated" />
            <FormControlLabel control={<Radio value="scheduled" color="primary" />} label="Scheduled" />
            <FormControlLabel control={<Radio value="completed" color="primary" />} label="Completed" />
          </RadioGroup>
        </Box>
        <Box marginBottom={'20px'}>
          <AbtestScheduleCurationList
            type="featuredcard"
            status={status}
            onClickRowItem={props.onClickRowItem}
            onDeleteCuration={handleDeleteCuration}
            onUpdateCuration={handleUpdateCuration}
            onError={props.onError}
          />
        </Box>
        <Box>
          <AbtestScheduleCurationList
            type="collection"
            status={status}
            onClickRowItem={props.onClickRowItem}
            onDeleteCuration={handleDeleteCuration}
            onUpdateCuration={handleUpdateCuration}
            onError={props.onError}
          />
        </Box>
      </Box>
    </div>
  );
};
